import React from "react";
import LmsModuleWorkspace from "./lmsModuleWorkspace";

// Step 2 "Learning content": a single tree column that carries the module list
// (add / drag-reorder / select) AND the selected module's element sequence,
// beside a contextual editor. All of it lives in LmsModuleWorkspace now — this
// stays as the stable entry point imported by the wizard and the workspace
// Content tab.
const LmsLearningContentStep = ({
  courseId,
  course,
  modules = [],
  onRefresh,
  registerUnsavedChangesGuard,
  setWizardDirty
}) => (
  <LmsModuleWorkspace
    courseId={courseId}
    course={course}
    modules={modules}
    onRefresh={onRefresh}
    registerUnsavedChangesGuard={registerUnsavedChangesGuard}
    setWizardDirty={setWizardDirty}
  />
);

export default LmsLearningContentStep;
